/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * TextTypeButton Component
 *
 * Renders a styled text container that uses a tooltip to display the full text
 * when it is truncated in the UI.
 *
 * @param {string} text
 *        The text content to display inside the component.
 *        If the text is too long, the component will show it truncated
 *        and reveal the full value using the CustomTooltip component.
 * @param {boolean} [disabled=false]  When true, the button becomes visually disabled and non-interactive.
 * @param {boolean} [copyOnClick=false] - Enables copying the text value when the text button is clicked.
 */

import { toast } from 'react-toastify';
import { IconToCopy } from '../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../components/CustomTooltip';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';

const TextTypeButton = ({ text, disabled, copyOnClick = false }) => {
    const { t } = useTranslation();
    const handleCopy = () => {
        if (disabled || !copyOnClick) return;
        const success = copy(text);
        if (success) {
            toast.success(t('text_copied_successfully'));
        } else {
            toast.error(t('failed_to_copy_text'));
        }
    };

    return (
        <div
            onClick={handleCopy}
            className={`border-radius-8px ibl-font-w-600 p-2 fs-14px text-ellipsis ${disabled ? 'background-shades-200 font-color-shades-400 cursor-not-allowed' : 'border-full-secondary-600 font-color-secondary-600'}`}
        >
            <CustomTooltip
                text={text}
                classes='fs-12px text-ellipsis-1-row'
                showIfTruncated={true}
                icon={<IconToCopy className={` ${disabled ? 'icon-color-shades-400': 'icon-color-secondary-600'} h-24px w-24px mr-2`} />}
            />
        </div>
    );
};

export default TextTypeButton;
